module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfABc4EsA.9d484aa9.woff2";